export const TrsanscriptIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
    <mask id="path-1-inside-1_2859_30438" fill="currentColor">
      <path d="M2.10498 7.91406H3.15726V12.553H2.10498V7.91406Z" />
    </mask>
    <path d="M2.10498 7.91406H3.15726V12.553H2.10498V7.91406Z" fill="currentColor" />
    <path
      d="M2.10498 7.91406V6.58073H0.771647V7.91406H2.10498ZM3.15726 7.91406H4.49059V6.58073H3.15726V7.91406ZM3.15726 12.553V13.8864H4.49059V12.553H3.15726ZM2.10498 12.553H0.771647V13.8864H2.10498V12.553ZM2.10498 9.2474H3.15726V6.58073H2.10498V9.2474ZM1.82393 7.91406V12.553H4.49059V7.91406H1.82393ZM3.15726 11.2197H2.10498V13.8864H3.15726V11.2197ZM3.43831 12.553V7.91406H0.771647V12.553H3.43831Z"
      fill="currentColor"
      mask="url(#path-1-inside-1_2859_30438)"
    />
    <path d="M16.8433 7.91406H17.8955V12.553H16.8433V7.91406Z" fill="currentColor" />
    <path d="M12.6313 7.91406H13.6836V12.553H12.6313V7.91406Z" fill="currentColor" />
    <path d="M8.42139 7.91406H9.47367V12.553H8.42139V7.91406Z" fill="currentColor" />
    <path d="M4.21069 5.59375H5.26297V14.8679H4.21069V5.59375Z" fill="currentColor" />
    <path d="M10.5266 5.59375H11.5789V14.8679H10.5266V5.59375Z" fill="currentColor" />
    <path d="M14.7698 3.27344H15.8221V17.1831H14.7698V3.27344Z" fill="currentColor" />
    <path d="M6.31909 0.953125H7.37137V19.5034H6.31909V0.953125Z" fill="currentColor" />
    <path d="M-0.000732422 9.45898H1.05155V11.0053H-0.000732422V9.45898Z" fill="currentColor" />
    <path d="M18.9478 9.45898H20V11.0053H18.9478V9.45898Z" fill="currentColor" />
  </svg>
);
